/* eslint-disable @typescript-eslint/no-unused-vars */
import Default from "../Pages/Dashboard/Default/Default";
import Charts from "../Pages/Widgets/Charts/Charts";
import General from "../Pages/Widgets/General/General";
import BasicTable from "../Pages/Tables/ReactstrapTable/BasicTable/BasicTable";
import TableComponent from "../Pages/Tables/ReactstrapTable/TableComponent/TableComponent";
import TwoFactor from "../Pages/Forms/FormsLayout/TwoFactor/TwoFactor";
import FormWizardTwo from "../Pages/Forms/FormsLayout/FormWizardTwo/FormWizardTwo";
import FormWizardOne from "../Pages/Forms/FormsLayout/FormWizardOne/FormWizardOne";
import Switch from "../Pages/Forms/FormsWidgets/Switch/Switch";
import Typeahead from "../Pages/Forms/FormsWidgets/Typeahead/Typeahead";
import ClipBoard from "../Pages/Forms/FormsWidgets/ClipBoard/ClipBoard";
import DatePicker from "../Pages/Forms/FormsWidgets/DatePicker/DatePicker";
import TouchSpin from "../Pages/Forms/FormsWidgets/TouchSpin/TouchSpin";
import MegaOption from "../Pages/Forms/FormsControl/MegaOption/MegaOption";
import InputGroup from "../Pages/Forms/FormsControl/InputGroup/InputGroup";
import InputMask from "../Pages/Forms/FormsControl/InputMask/InputMask";
import RadioCheckbox from "../Pages/Forms/FormsControl/RadioCheckbox/RadioCheckbox";
import FormsValidation from "../Pages/Forms/FormsControl/FormsValidation/FormsValidation";
import BaseInput from "../Pages/Forms/FormsControl/BaseInput/BaseInput";
import ApexChart from "../Pages/Charts/Apexchart/ApexChart";
import GoogleChart from "../Pages/Charts/GoogleChart/GoogleChart";
import ChartJs from "../Pages/Charts/ChartJs/ChartJs";
import Todo from "../Pages/Application/Todo/Todo";
import ProjectList from "../Pages/Application/Project/ProjectList/ProjectList";
import ProjectCreate from "../Pages/Application/Project/ProjectCreate/ProjectCreate";
import SamplePage from "../Pages/SamplePage/SamplePage";
import SupportTicket from "../Pages/Miscellaneous/SupportTicket/SupportTicket";
import BlogDetails from "../Pages/Miscellaneous/Blog/BlogDetails/BlogDetails";
import BlogSingle from "../Pages/Miscellaneous/Blog/BlogSingle/BlogSingle";
import AddPost from "../Pages/Miscellaneous/Blog/AddPost/AddPost";
import BasicInit from "../Pages/Tables/DataTables/BasicInit/BasicInit";
import AdvanceInit from "../Pages/Tables/DataTables/AdvanceInit/AdvanceInit";
import ApiDataTable from "../Pages/Tables/DataTables/ApiDataTable/ApiDataTable";
import DataSource from "../Pages/Tables/DataTables/DataSource/DataSource";
import ProductPage from "../Pages/Application/Ecommerce/ProductPage/ProductPage";
import ProductList from "../Pages/Application/Ecommerce/ProductList/ProductList";
import PaymentDetails from "../Pages/Application/Ecommerce/PaymentDetails/PaymentDetails";
import WishList from "../Pages/Application/Ecommerce/WishList/WishList";
import Pricing from "../Pages/Application/Ecommerce/Pricing/Pricing";
import OrderHistory from "../Pages/Application/Ecommerce/OrderHistory/OrderHistory";
import PrivateChat from "../Pages/Application/Chat/PrivateChat/PrivateChat";
import GroupChat from "../Pages/Application/Chat/GroupChat/GroupChat";
import UsersProfile from "../Pages/Application/Users/UsersProfile/UsersProfile";
import EditProfile from "../Pages/Application/Users/EditProfile/EditProfile";
import UserCards from "../Pages/Application/Users/UserCards/UserCards";
import Products from "../Pages/Application/Ecommerce/Products/Products";
import Cart from "../Pages/Application/Ecommerce/Cart/Cart";
import Checkout from "../Pages/Application/Ecommerce/Checkout/Checkout";
import AddProduct from "../Pages/Application/Ecommerce/AddProduct/AddProduct";
import InvoiceOne from "../Pages/Application/Ecommerce/Invoices/Invoice-1/Invoice-1";
import InvoiceTwo from "../Pages/Application/Ecommerce/Invoices/Invoice-2/Invoice-2";
import InvoiceThree from "../Pages/Application/Ecommerce/Invoices/Invoice-3/Invoice-3";
import InvoiceFour from "../Pages/Application/Ecommerce/Invoices/Invoice-4/Invoice-4";
import InvoiceFive from "../Pages/Application/Ecommerce/Invoices/Invoice-5/Invoice-5";
import InvoiceSix from "../Pages/Application/Ecommerce/Invoices/Invoice-6/Invoice-6";
import LetterBox from "../Pages/Application/LetterBox/LetterBox";



import TicketPlanList from "../Pages/Application/Ticket/TicketPlanList/TicketPlanList";
import TicketCreate from "../Pages/Application/Ticket/TicketPlanList/TicketCreate";
import OfferList from "../Pages/Application/Master/offer/OfferList";
import OfferCreate from "../Pages/Application/Master/offer/OfferCreate";
import RfidCardList from "../Pages/Application/Master/rfid/RfidCardList";
import RfidCardCreate from "../Pages/Application/Master/rfid/RfidCardCreate";
import ClothCreate from "../Pages/Application/Master/cloth/ClothCreate";
import ClothList from "../Pages/Application/Master/cloth/ClothList";
import LockerCreate from "../Pages/Application/Master/locker/LockerCreate";
import LockerList from "../Pages/Application/Master/locker/LockerList";
import CLothAssign from "../Pages/SamplePage/ClothAssign";
import Food from "../Pages/Food/Food"; // Adjusted path to match the correct module location
import LockerAssign from "../Pages/SamplePage/LockerAssign";
import RechargeAmountGrid from "../Pages/SamplePage/RechargeAmountGrid";
import CardAssign from "../Pages/Cardasign/CardAssign";
import BookTicket from "../Pages/Application/Master/book_ticket/BookTicket";
import BookingHistory from "../Pages/Application/Master/book_ticket/BookingHistory";
import AllCardAssign from "../Pages/Application/Master/book_ticket/AllCardAssign";
import RechargeHistory from "../Pages/Application/Master/book_ticket/RechargeHistory";
import RechargeCreate from "../Pages/Application/Master/rfid/RechargeCreate";
import RechargeList from "../Pages/Application/Master/rfid/RechargeList";
import CategoryCreate from "../Pages/Application/Food/category/CategoryCreate";
import FoodCreate from "../Pages/Application/Food/product/FoodCreate";
import CategoryList from "../Pages/Application/Food/category/CategoryList";
import FoodList from "../Pages/Application/Food/product/FoodList";
import AllLockerAssign from "../Pages/Application/Master/book_ticket/AllLockerAssign";
import BookingCancelled from "../Pages/Application/Master/book_ticket/BookingCancelled";
import CouponCreate from "../Pages/Application/Master/cloth/CouponCreate";
import CouponList from "../Pages/Application/Master/cloth/CouponList";
import AllClothAssign from "../Pages/Application/Master/book_ticket/AllClothAssign";
import AllFoodOrder from "../Pages/Application/Master/book_ticket/AllFoodOrder";
import AllStaffs from "../Pages/Application/Master/book_ticket/AllStaffs";
import RefundList from "../Pages/Application/Master/book_ticket/RefundList";
import AccountSettings from "../Pages/SamplePage/AccountSettings";
import AccountProfile from "../Pages/SamplePage/AccountProfile";
import GstReport from "../Pages/SamplePage/GstReport";
import LockerReport from "../Pages/SamplePage/LockerReport";
import RefundReport from "../Pages/SamplePage/RefundReport";
import ClothReport from "../Pages/SamplePage/ClothReport";
import BookingReport from "../Pages/SamplePage/BookingReport";
import FoodReport from "../Pages/SamplePage/FoodReport";
import BookingHistoryReport from "../Pages/SamplePage/BookingHistoryReport";
import PrintFoodOrder from "../Pages/Application/Master/book_ticket/PrintFoodOrder";
import BookingInvoice from "../Pages/Application/Master/book_ticket/BookingInvoice";
import LockerInvoice from "../Pages/Application/Master/book_ticket/LockerInvoice";
import ClothInvoice from "../Pages/Application/Master/book_ticket/ClothInvoice";
import ChangePassword from "../Pages/SamplePage/ChangePassword";
import NewStaffAdd from "../Pages/Application/Master/book_ticket/StaffAdd";
import AllTicketOfferList from "../Pages/Application/Master/offer/AllTicketOfferList";


const routes = [
  // dashboard
  { path: `${process.env.PUBLIC_URL}/dashboard/default`, Component: <Default /> },

  // Widgets
  { path: `${process.env.PUBLIC_URL}/widgets/general`, Component: <General /> },
  { path: `${process.env.PUBLIC_URL}/widgets/chart`, Component: <Charts /> },

  // master
  { path: `${process.env.PUBLIC_URL}/ticket/create_ticket_offer`, Component: <OfferCreate /> },
  { path: `${process.env.PUBLIC_URL}/ticket/all_ticket_offer`, Component: <AllTicketOfferList /> },
  { path: `${process.env.PUBLIC_URL}/offer/offer_list`, Component: <OfferList /> },
  { path: `${process.env.PUBLIC_URL}/offer/create_new`, Component: <OfferCreate /> },
  { path: `${process.env.PUBLIC_URL}/rfidCard/rfidCardList`, Component: <RfidCardList /> },
  { path: `${process.env.PUBLIC_URL}/rfidCard/create_new`, Component: <RfidCardCreate /> },
  { path: `${process.env.PUBLIC_URL}/cloth/clothList`, Component: <ClothList /> },
  { path: `${process.env.PUBLIC_URL}/cloth/create_new`, Component: <ClothCreate /> },
  { path: `${process.env.PUBLIC_URL}/coupon/create_new`, Component: <CouponCreate /> },
  { path: `${process.env.PUBLIC_URL}/coupon/coupon_list`, Component: <CouponList /> },
  { path: `${process.env.PUBLIC_URL}/locker/lockerList`, Component: <LockerList /> },
  { path: `${process.env.PUBLIC_URL}/locker/create_new`, Component: <LockerCreate /> },
  { path: `${process.env.PUBLIC_URL}/recharge/create_new`, Component: <RechargeCreate /> },
  { path: `${process.env.PUBLIC_URL}/recharge/rechargeList`, Component: <RechargeList /> },

   // Ticket Plan
   { path: `${process.env.PUBLIC_URL}/ticket/ticket_plan_list`, Component: <TicketPlanList /> },
   { path: `${process.env.PUBLIC_URL}/ticket/create_new`, Component: <TicketCreate /> },
   { path: `${process.env.PUBLIC_URL}/cloth/cloth_assign`, Component: <CLothAssign /> },
   { path: `${process.env.PUBLIC_URL}/cloth/all_cloth_assign`, Component: <AllClothAssign/> },
   { path: `${process.env.PUBLIC_URL}/locker/locker_assign`, Component: <LockerAssign /> },
   { path: `${process.env.PUBLIC_URL}/locker/all_locker_assign`, Component: <AllLockerAssign/> },

   // Ticket Booking
   { path: `${process.env.PUBLIC_URL}/ticket/book_ticket`, Component: <BookTicket /> },
   { path: `${process.env.PUBLIC_URL}/ticket/booking_history`, Component: <BookingHistory /> },
   { path: `${process.env.PUBLIC_URL}/ticket/booking_cancelled`, Component: <BookingCancelled /> },

  // Recharge
    { path: `${process.env.PUBLIC_URL}/ticket/ticket_plan_list`, Component: <TicketPlanList /> },
    { path: `${process.env.PUBLIC_URL}/recharge/card_recharge`, Component: <RechargeAmountGrid /> },
    { path: `${process.env.PUBLIC_URL}/recharge/recharge_history`, Component: <RechargeHistory /> },


  // Card 
  { path: `${process.env.PUBLIC_URL}/card/card_assign`, Component: <CardAssign/> },
  { path: `${process.env.PUBLIC_URL}/card/all_card_assign`, Component: <AllCardAssign/> },


    // Food
   { path: `${process.env.PUBLIC_URL}/food/food_order`, Component: <Food/> },
   { path: `${process.env.PUBLIC_URL}/food/all_food_order`, Component: <AllFoodOrder/> },

   // Account
   { path: `${process.env.PUBLIC_URL}/account/account_settings/:id?`, Component: <AccountSettings /> },
   { path: `${process.env.PUBLIC_URL}/account/account_profile`, Component: <AccountProfile /> },


  // Project
  { path: `${process.env.PUBLIC_URL}/project/project_list`, Component: <ProjectList /> },
  { path: `${process.env.PUBLIC_URL}/project/create_new`, Component: <ProjectCreate /> },
  // Ecommerce
  { path: `${process.env.PUBLIC_URL}/food/add_category`, Component: <CategoryCreate /> },
  { path: `${process.env.PUBLIC_URL}/food/categoryList`, Component: <CategoryList /> },
  { path: `${process.env.PUBLIC_URL}/food/add_food`, Component: <FoodCreate /> },
  { path: `${process.env.PUBLIC_URL}/food/foodList`, Component: <FoodList /> },

  { path: `${process.env.PUBLIC_URL}/ecommerce/products`, Component: <Products /> },
  { path: `${process.env.PUBLIC_URL}/ecommerce/product_page`, Component: <ProductPage /> },
  { path: `${process.env.PUBLIC_URL}/ecommerce/product_list`, Component: <ProductList /> },
  { path: `${process.env.PUBLIC_URL}/ecommerce/payment_details`, Component: <PaymentDetails /> },
  { path: `${process.env.PUBLIC_URL}/ecommerce/order_history`, Component: <OrderHistory /> },
  // Invoices
  { path: `${process.env.PUBLIC_URL}/ecommerce/invoice/invoice1`, Component: <InvoiceOne /> },
  { path: `${process.env.PUBLIC_URL}/ecommerce/invoice/invoice2`, Component: <InvoiceTwo /> },
  { path: `${process.env.PUBLIC_URL}/ecommerce/invoice/invoice3`, Component: <InvoiceThree /> },
  { path: `${process.env.PUBLIC_URL}/ecommerce/invoice/invoice4`, Component: <InvoiceFour /> },
  { path: `${process.env.PUBLIC_URL}/ecommerce/invoice/invoice5`, Component: <InvoiceFive /> },
  { path: `${process.env.PUBLIC_URL}/ecommerce/invoice/invoice6`, Component: <InvoiceSix /> },
  { path: `${process.env.PUBLIC_URL}/ecommerce/cart`, Component: <Cart /> },
  { path: `${process.env.PUBLIC_URL}/ecommerce/wishlist`, Component: <WishList /> },
  { path: `${process.env.PUBLIC_URL}/ecommerce/checkout`, Component: <Checkout /> },
  { path: `${process.env.PUBLIC_URL}/ecommerce/pricing`, Component: <Pricing /> },

  // LetterBox
  { path: `${process.env.PUBLIC_URL}/email/letter_box`, Component: <LetterBox /> },

  // Chat
  { path: `${process.env.PUBLIC_URL}/chat/private_chat`, Component: <PrivateChat /> },
  { path: `${process.env.PUBLIC_URL}/chat/group_chat`, Component: <GroupChat /> },

  // Reports
  { path: `${process.env.PUBLIC_URL}/report/refund-list`, Component: <RefundList /> },
  { path: `${process.env.PUBLIC_URL}/report/gst-report`, Component: <GstReport /> },
  { path: `${process.env.PUBLIC_URL}/report/refund-report`, Component: <RefundReport /> },
  { path: `${process.env.PUBLIC_URL}/report/locker-report`, Component: <LockerReport /> },
  { path: `${process.env.PUBLIC_URL}/report/cloth-report`, Component: <ClothReport /> },
  { path: `${process.env.PUBLIC_URL}/report/booking-report`, Component: <BookingReport /> },
  { path: `${process.env.PUBLIC_URL}/report/food-report`, Component: <FoodReport /> },
  { path: `${process.env.PUBLIC_URL}/report/booking-history-report/:staffid`, Component: <BookingHistoryReport /> },

  // Users
  { path: `${process.env.PUBLIC_URL}/users/user_profile`, Component: <UsersProfile /> },
  { path: `${process.env.PUBLIC_URL}/users/user_edit`, Component: <EditProfile /> },
  { path: `${process.env.PUBLIC_URL}/users/cards`, Component: <UserCards /> },
  { path: `${process.env.PUBLIC_URL}/staffs/all-staffs`, Component: <AllStaffs /> },
  { path: `${process.env.PUBLIC_URL}/staffs/new_staff_add`, Component: <NewStaffAdd /> },
  { path: `${process.env.PUBLIC_URL}/account/ChangePassword/:id?`, Component: <ChangePassword /> },

  // Todo
  { path: `${process.env.PUBLIC_URL}/app/todo`, Component: <Todo /> },

  // Forms Control
  { path: `${process.env.PUBLIC_URL}/forms/forms_controls/form_validation`, Component: <FormsValidation /> },
  { path: `${process.env.PUBLIC_URL}/forms/forms_controls/base_input`, Component: <BaseInput /> },
  { path: `${process.env.PUBLIC_URL}/forms/forms_controls/radio_checkbox`, Component: <RadioCheckbox /> },
  { path: `${process.env.PUBLIC_URL}/forms/forms_controls/input_groups`, Component: <InputGroup /> },
  { path: `${process.env.PUBLIC_URL}/forms/forms_controls/input_mask`, Component: <InputMask /> },
  { path: `${process.env.PUBLIC_URL}/forms/forms_controls/mega_option`, Component: <MegaOption /> },

  // Forms Widgets
  { path: `${process.env.PUBLIC_URL}/forms/forms_widget/datepicker`, Component: <DatePicker /> },
  { path: `${process.env.PUBLIC_URL}/forms/forms_widget/touchspin`, Component: <TouchSpin /> },
  { path: `${process.env.PUBLIC_URL}/forms/forms_widget/switch`, Component: <Switch /> },
  { path: `${process.env.PUBLIC_URL}/forms/forms_widget/typeahead`, Component: <Typeahead /> },
  { path: `${process.env.PUBLIC_URL}/forms/forms_widget/clipboard`, Component: <ClipBoard /> },

  // Forms Layout
  { path: `${process.env.PUBLIC_URL}/forms/forms_layout/form_wizard_1`, Component: <FormWizardOne /> },
  { path: `${process.env.PUBLIC_URL}/forms/forms_layout/form_wizard_2`, Component: <FormWizardTwo /> },
  { path: `${process.env.PUBLIC_URL}/forms/forms_layout/two_factor`, Component: <TwoFactor /> },

  // Tables
  { path: `${process.env.PUBLIC_URL}/table/reactstrap_table/basic_table`, Component: <BasicTable /> },
  { path: `${process.env.PUBLIC_URL}/table/reactstrap_table/table_component`, Component: <TableComponent /> },

  // Data Tables
  { path: `${process.env.PUBLIC_URL}/table/data_table/basic_init`, Component: <BasicInit /> },
  { path: `${process.env.PUBLIC_URL}/table/data_table/advance_init`, Component: <AdvanceInit /> },
  { path: `${process.env.PUBLIC_URL}/table/data_table/api`, Component: <ApiDataTable /> },
  { path: `${process.env.PUBLIC_URL}/table/data_table/data_sources`, Component: <DataSource /> },
  // Charts
  { path: `${process.env.PUBLIC_URL}/charts/apex_chart`, Component: <ApexChart /> },
  { path: `${process.env.PUBLIC_URL}/charts/google_chart`, Component: <GoogleChart /> },
  { path: `${process.env.PUBLIC_URL}/charts/chartjs_chart`, Component: <ChartJs /> },

  // Pages
  { path: `${process.env.PUBLIC_URL}/pages/sample_page`, Component: <SamplePage /> },

  // Blog
  { path: `${process.env.PUBLIC_URL}/blog/blog_details`, Component: <BlogDetails /> },
  { path: `${process.env.PUBLIC_URL}/blog/blog_single`, Component: <BlogSingle /> },
  { path: `${process.env.PUBLIC_URL}/blog/add_post`, Component: <AddPost /> },

  // Support Ticket
  { path: `${process.env.PUBLIC_URL}/support_ticket/support_ticket`, Component: <SupportTicket /> },

  //  print food order
  { path: `${process.env.PUBLIC_URL}/print-food-order/:id`, Component: <PrintFoodOrder /> },
  { path: `${process.env.PUBLIC_URL}/ticket-booking-invoice/:id`, Component: <BookingInvoice /> },
  { path: `${process.env.PUBLIC_URL}/print-locker-invoice/:id`, Component: <LockerInvoice /> },
  { path: `${process.env.PUBLIC_URL}/print-cloth-invoice/:id`, Component: <ClothInvoice /> },

];

export default routes;
